import React from 'react';
import CircularProgress from "@material-ui/core/CircularProgress";
// import LinearProgress from "@material-ui/core/LinearProgress";
import { makeStyles } from '@material-ui/core';
// import Logo from 'assets/images/logo512.png';


export const Loading = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.container} style={{ backgroundColor: props.backgroundColor ? props.backgroundColor : '#fff' }} >
      <CircularProgress color="secondary" />
    </div>
  );
}

const useStyles = makeStyles(theme => {
  return ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      height: '80vh',
      overflow: 'hidden',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
});
